// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"199":"47ed9604","703":"0443b0ea","872":"94a94400"}[chunkId] + ".chunk.js";
};